export function deriveMemberDisplayId(seasonMembershipId: string): string {
  const left = fnv1a64(`member-display:${seasonMembershipId}`);
  const right = fnv1a64(`member-display-stable-key:${seasonMembershipId}`);

  return `memberDisplay_${left.toString(36)}_${right.toString(36)}`;
}

function fnv1a64(value: string): bigint {
  let hash = 0xcbf29ce484222325n;
  const bytes = new TextEncoder().encode(value);

  for (const byte of bytes) {
    hash ^= BigInt(byte);
    hash = BigInt.asUintN(64, hash * 0x100000001b3n);
  }

  return hash;
}
